import { useLocation } from 'react-router-dom';

export default function useRedirect() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const redirectUrl = searchParams.get('redirectUrl');

  const redirect = () => {
    window.location.replace(redirectUrl ? redirectUrl : 'https://store.kkoruruk.com');
  };

  return {
    redirect,
    redirectUrl,
  };
}
